import { FetchExperiences, ReorderExperiences } from "../../redux/experience";
import { IoCheckboxOutline, IoCloseSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";

import { AppLinks } from "../../components/links";
import { DragDropContainer } from "../../components/inputs";
import { ErrorBanner } from "../../components/banner";
import { IoPencilOutline } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";
import { useEffect } from "react";

export const ExperienceList = () => {
  const { exps, loading, error } = useSelector((state) => state.experiences);
  const dispatch = useDispatch();

  const handleReorder = (reorderedList) => {
    dispatch(ReorderExperiences(reorderedList));
  };

  useEffect(() => {
    dispatch(FetchExperiences());
  }, [dispatch]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Section>
        {error && <ErrorBanner text={error} />}
        <Section>
          <DataRowListHeader>
            <Text>Order</Text>
            <Text>Title</Text>
            <Text>Featured</Text>
            <Text>Edit</Text>
          </DataRowListHeader>
          <DragDropContainer
            items={exps}
            onReorder={handleReorder}
            renderItem={(experience, index) => (
              <DataRowList>
                <Text>{index + 1}</Text>
                <Text>{experience.title}</Text>
                <div className="svgc">
                  {experience.featured ? (
                    <IoCheckboxOutline />
                  ) : (
                    <IoCloseSharp />
                  )}
                </div>
                <AppLinks
                  to={`/about/experiences/${experience.id}/edit`}
                  state={{ experience: experience }}
                >
                  <IoPencilOutline />
                </AppLinks>
              </DataRowList>
            )}
          />
        </Section>
      </Section>
    </>
  );
};

const DataRowListHeader = styled.header`
  display: grid;
  grid-template-columns: 0.1fr 2fr 0.2fr 0.17fr;
  font-size: 0.9rem;
  font-weight: 500;
  gap: 0.5rem;
  text-align: left;
  padding: 0 10px;
`;

const DataRowList = styled.div`
  display: grid;
  grid-template-columns: 0.1fr 2fr 0.1fr 0.2fr;
  align-items: center;
  gap: 0.5rem;
  padding: 10px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
  cursor: grab;

  p {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  svg {
    align-items: center;
    margin: auto;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;
